import { ActionContext, ActionTree } from "vuex";
import { GetterTree } from "vuex";
import { SubHeaderData } from "@/model/SubHeaderData";

export interface SubHeaderState {
  inspectTime: number;
  maintenanceExpectTime: number;
  maintenanceTime: number;
  sknWorkProgressStateId: number;
  sknWorkProgressStateNm: string;
  // isInspecting: boolean;
  // isMaintaining: boolean;
  isSavePayment: boolean;
  waitPartsSelect: boolean;
}

const initialState: SubHeaderState = {
  inspectTime: 0,
  maintenanceExpectTime: 0,
  maintenanceTime: 0,
  sknWorkProgressStateId: 0,
  sknWorkProgressStateNm: "",
  // isInspecting: false,
  // isMaintaining: false,
  isSavePayment: false,
  waitPartsSelect: true
};

// inspectTime, maintenanceTime, maintenanceExpectTime unit is 'minute'

const actions: ActionTree<SubHeaderState, any> = {
  setSubHeaderData(
    { commit }: ActionContext<SubHeaderState, any>,
    payload: SubHeaderData
  ): void {
    commit("setSubHeaderData", payload);
  },
  setMaintenanceExpectTime(
    { commit }: ActionContext<SubHeaderState, any>,
    payload: number
  ): void {
    commit("setMaintenanceExpectTime", payload);
  },
  // setInspecting(
  //   { commit }: ActionContext<SubHeaderState, any>,
  //   payload: boolean
  // ): void {
  //   commit("setInspecting", payload);
  // },
  // setMaintaining(
  //   { commit }: ActionContext<SubHeaderState, any>,
  //   payload: boolean
  // ): void {
  //   commit("setMaintaining", payload);
  // },
  setProgressState(
    { commit }: ActionContext<SubHeaderState, any>,
    payload: { stateId: number; stateNm: string }
  ): void {
    commit("setProgressState", payload);
  },
  setIsSavePaymente({ commit }: ActionContext<SubHeaderState, any>): void {
    commit("setIsSavePaymente");
  },
  updateWaitPartSelect(
    { commit }: ActionContext<SubHeaderState, any>,
    payload: boolean
  ): void {
    commit("updateWaitPartSelect", payload);
  },
  clearState({ commit }: ActionContext<SubHeaderState, any>): void {
    commit("clearState");
  },
  setInspectTime(
    { commit }: ActionContext<SubHeaderState, any>,
    payload: number
  ): void {
    commit("setInspectTime", payload);
  },
  setMaintenanceTime(
    { commit }: ActionContext<SubHeaderState, any>,
    payload: number
  ): void {
    commit("setMaintenanceTime", payload);
  }
};

const mutations = {
  setSubHeaderData(state: SubHeaderState, payload: SubHeaderData) {
    if (payload.sknInspectTime) {
      state.inspectTime = Number(payload.sknInspectTime);
    }
    if (payload.sknMaintenanceExpectTime) {
      state.maintenanceExpectTime = Number(payload.sknMaintenanceExpectTime);
    }
    if (payload.sknMaintenanceTime) {
      state.maintenanceTime = Number(payload.sknMaintenanceTime);
    }
    mutations.setProgressState(state, {
      stateId: payload.sknWorkProgressStateId,
      stateNm: payload.sknWorkProgressStateNm
    });

    if (state.waitPartsSelect) {
      if (
        payload.sknWorkProgressStateId &&
        payload.sknWorkProgressStateId > 5
      ) {
        state.waitPartsSelect = false;
      } else {
        state.waitPartsSelect = true;
      }
    }
  },
  setMaintenanceExpectTime(state: SubHeaderState, payload: number) {
    state.maintenanceExpectTime = payload;
  },
  // setInspecting(state: SubHeaderState, payload: boolean) {
  //   state.isInspecting = payload;
  // },
  // setMaintaining(state: SubHeaderState, payload: boolean) {
  //   state.isMaintaining = payload;
  // },
  setProgressState(state: SubHeaderState, payload: any) {
    if (payload.stateId && payload.stateId > -1) {
      state.sknWorkProgressStateId = payload.stateId;
      state.sknWorkProgressStateNm = payload.stateNm;
    }
  },
  setIsSavePaymente(state: SubHeaderState) {
    state.isSavePayment = true;
  },
  updateWaitPartSelect(state: SubHeaderState, payload: boolean) {
    state.waitPartsSelect = payload;
  },
  clearState(state: SubHeaderState) {
    Object.assign(state, { ...initialState });
  },
  setInspectTime(state: SubHeaderState, payload: number) {
    state.inspectTime = payload;
  },
  setMaintenanceTime(state: SubHeaderState, payload: number) {
    state.maintenanceTime = payload;
  },
};

const getters: GetterTree<SubHeaderState, any> = {
  inspectTime(state: SubHeaderState): any {
    return state.inspectTime;
  },
  maintenanceTime(state: SubHeaderState): any {
    return state.maintenanceTime;
  },
  maintenanceExpectTime(state: SubHeaderState): any {
    return state.maintenanceExpectTime;
  },
  stateId(state: SubHeaderState) {
    return state.sknWorkProgressStateId;
  },
  stateNm(state: SubHeaderState) {
    return state.sknWorkProgressStateNm;
  },
  // isInspecting(state: SubHeaderState): any {
  //   return state.isInspecting;
  // },
  // isMaintaining(state: SubHeaderState): any {
  //   return state.isMaintaining;
  // },
  waitPartsSelect(state: SubHeaderState): any {
    return state.waitPartsSelect;
  },
  isSavePayment(state: SubHeaderState): any {
    return state.isSavePayment;
  }
};

const namespaced: boolean = true;
export default {
  namespaced,
  state: { ...initialState },
  getters,
  actions,
  mutations
};
